import { Input } from 'antd';

import { trackButtonClick } from '../../analytics/mixpanel';
import NextArrowIcon from '../../assets/NextArrowIcon';
import PreviousArrowIcon from '../../assets/PreviousArrowIcon';
import ZoomInIcon from '../../assets/ZoomInIcon';
import ZoomOutIcon from '../../assets/ZoomOutIcon';
import {
  addition,
  MAX_ZOOM_LEVEL,
  MIN_ZOOM_LEVEL,
  modifiedDocument,
  originalDocument,
  singleDocument,
  substraction,
} from '../../Constants/commonConstants';
import { zoomControl } from '../utils';

function ViewerFooter({
  page,
  goToPage,
  zoomLevel,
  setZoomLevel,
  documentDetails,
  editablePageHandler,
  currentTab,
  tabView,
  currentDocument,
  sideBarVisible,
}) {
  return (
    <footer
      className='compare-doc-footer'
      style={{ paddingLeft: `${sideBarVisible ? 288 : 76}px` }}
    >
      {tabView ? (
        <div className='footer-doc-left'>
          <button
            onClick={() => {
              // trackButtonClick({ type: 'Zoom Out Original document' });
              zoomControl(singleDocument, substraction, setZoomLevel);
            }}
            disabled={zoomLevel.SINGLE_DOCUMENT < MIN_ZOOM_LEVEL}
          >
            <ZoomOutIcon />
            <div>Zoom Out</div>
          </button>
          <span className='flex-items'>
            <button
              onClick={() => {
                // trackButtonClick({ type: 'Previous Page Original document' });
                goToPage(singleDocument, page.SINGLE_DOCUMENT.number - 1);
              }}
              disabled={page.SINGLE_DOCUMENT.number <= 1}
            >
              <PreviousArrowIcon />
              <div>Previous Page</div>
            </button>
            <div className='page-number-container'>
              <div className='page-number mb-8'>
                <Input
                  value={page.SINGLE_DOCUMENT.number === 0 ? '' : page.SINGLE_DOCUMENT.number}
                  className='editable-page'
                  onChange={(e) =>
                    !isNaN(e.target.value) &&
                    editablePageHandler('singleRegion', Number(e.target.value))
                  }
                />{' '}
                <p>
                  &nbsp;of&nbsp;
                  {documentDetails?.[currentTab]?.total_page}
                </p>
              </div>
              <div>Page Number</div>
            </div>
            <button
              onClick={() => {
                // trackButtonClick({ type: 'Next Page Original document' });
                goToPage(singleDocument, page.SINGLE_DOCUMENT.number + 1);
              }}
              disabled={page.SINGLE_DOCUMENT.number === documentDetails?.[currentTab]?.total_page}
            >
              <NextArrowIcon />
              <div>Next Page</div>
            </button>
          </span>
          <button
            onClick={() => {
              // trackButtonClick({
              //   type: 'Zoom In Original document',
              // });
              zoomControl(singleDocument, addition, setZoomLevel);
            }}
            disabled={zoomLevel.SINGLE_DOCUMENT >= MAX_ZOOM_LEVEL}
          >
            <ZoomInIcon />
            <div>Zoom In</div>
          </button>
        </div>
      ) : (
        <>
          <div className='footer-doc-left'>
            <button
              onClick={() => {
                trackButtonClick({ type: 'Zoom Out Original document' });
                zoomControl(originalDocument, substraction, setZoomLevel);
              }}
              disabled={zoomLevel.ORIGINAL_DOCUMENT < MIN_ZOOM_LEVEL}
            >
              <ZoomOutIcon />
              <div>Zoom Out</div>
            </button>
            <span className='flex-items'>
              <button
                onClick={() => {
                  trackButtonClick({ type: 'Previous Page Original document' });
                  goToPage(originalDocument, page.ORIGINAL_DOCUMENT.number - 1);
                }}
                disabled={page.ORIGINAL_DOCUMENT.number <= 1}
              >
                <PreviousArrowIcon />
                <div>Previous Page</div>
              </button>
              <div className='page-number-container'>
                <div className='page-number mb-8'>
                  <Input
                    value={page.ORIGINAL_DOCUMENT.number === 0 ? '' : page.ORIGINAL_DOCUMENT.number}
                    className='editable-page'
                    onChange={(e) =>
                      !isNaN(e.target.value) &&
                      editablePageHandler('leftRegion', Number(e.target.value))
                    }
                  />{' '}
                  <p>&nbsp;of {documentDetails?.[currentDocument?.left]?.total_page}</p>
                </div>
                <div>Page Number</div>
              </div>
              <button
                onClick={() => {
                  trackButtonClick({ type: 'Next Page Original document' });
                  goToPage(originalDocument, page.ORIGINAL_DOCUMENT.number + 1);
                }}
                disabled={
                  page.ORIGINAL_DOCUMENT.number ===
                  documentDetails?.[currentDocument?.left]?.total_page
                }
              >
                <NextArrowIcon />
                <div>Next Page</div>
              </button>
            </span>
            <button
              onClick={() => {
                trackButtonClick({
                  type: 'Zoom In Original document',
                });
                zoomControl(originalDocument, addition, setZoomLevel);
              }}
              disabled={zoomLevel.ORIGINAL_DOCUMENT >= MAX_ZOOM_LEVEL}
            >
              <ZoomInIcon />
              <div>Zoom In</div>
            </button>
          </div>
          <div className='footer-doc-right'>
            <button
              onClick={() => {
                trackButtonClick({ type: 'Zoom Out Revised document' });
                zoomControl(modifiedDocument, substraction, setZoomLevel);
              }}
              disabled={zoomLevel.MODIFIED_DOCUMENT < MIN_ZOOM_LEVEL}
            >
              <ZoomOutIcon />
              <div>Zoom Out</div>
            </button>
            <span className='flex-items'>
              <button
                onClick={() => {
                  trackButtonClick({ type: 'Previous Page Revised document' });
                  goToPage(modifiedDocument, page.MODIFIED_DOCUMENT.number - 1);
                }}
                disabled={page.MODIFIED_DOCUMENT.number <= 1}
              >
                <PreviousArrowIcon />
                <div>Previous Page</div>
              </button>
              <div className='page-number-container'>
                <div className='page-number mb-8'>
                  <Input
                    value={page.MODIFIED_DOCUMENT.number === 0 ? '' : page.MODIFIED_DOCUMENT.number}
                    className='editable-page'
                    onChange={(e) =>
                      !isNaN(e.target.value) &&
                      editablePageHandler('rightRegion', Number(e.target.value))
                    }
                  />{' '}
                  <p>&nbsp;of {documentDetails?.[currentDocument?.right]?.total_page}</p>
                </div>
                <div>Page Number</div>
              </div>
              <button
                onClick={() => {
                  trackButtonClick({ type: 'Next Page Revised document' });
                  goToPage(modifiedDocument, page.MODIFIED_DOCUMENT.number + 1);
                }}
                disabled={
                  page.MODIFIED_DOCUMENT.number ===
                  documentDetails?.[currentDocument?.right]?.total_page
                }
              >
                <NextArrowIcon />
                <div>Next Page</div>
              </button>
            </span>
            <button
              onClick={() => {
                trackButtonClick({ type: 'Zoom In Revised document' });
                zoomControl(modifiedDocument, addition, setZoomLevel);
              }}
              disabled={zoomLevel.MODIFIED_DOCUMENT >= MAX_ZOOM_LEVEL}
            >
              <ZoomInIcon />
              <div>Zoom In</div>
            </button>
          </div>
        </>
      )}
    </footer>
  );
}

export default ViewerFooter;
